import api from '@/http'

const state = () => ({})

const getters = {}

const actions = {
  getCountriesOccupancy() {
    return new Promise((resolve, reject) => {
      api
        .get('countries/occupancy')
        .then(({ data, response }) => {
          resolve(data, response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCountries() {
    return new Promise((resolve, reject) => {
      api
        .get('countries')
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getRealCountries() {
    return new Promise((resolve, reject) => {
      api
        .get('real-countries')
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
